import React from "react";
import LoginForm from "../../components/LogIn-SignUp/LoginForm";
import Footer from "../../components/Footer";
import RenderSocial from "../../components/Render-social";
import IconButton from "../../components/IconButton/IconButton";
import { useDispatch } from "react-redux";
import { IconTypes } from "../../libs/Icon";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useNavigate } from "react-router-dom";

import UseClosePopUpHandler from "../../hooks/useClosePopUpHandler";
import GetUrl from "../../hooks/GetUrl";

import styles from "./styles.module.scss";

const Login = () => {
    const path = GetUrl();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const modalRef = useOutsideClick(() => UseClosePopUpHandler(path, dispatch));

    return (
        <div className={styles.container}>
            <div className={styles.wrapper} ref={modalRef}>
                <h6 className={styles.title}>Log in to Your Account</h6>
                <IconButton
                    buttonProps={{
                        onClick: () => UseClosePopUpHandler(path, dispatch),
                    }}
                    className={styles.closeButton}
                    size={32}
                    type={IconTypes.CLOSE_DELETE}
                />
                <RenderSocial />
                <LoginForm />
                <Footer
                    goTo="New to BoomForm?"
                    footerActionText="Create an account."
                    footerAction={() => {
                        navigate("/signup");
                    }}
                />
            </div>
        </div>
    );
};

export default Login;
